var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var ArrowVertical = function ArrowVertical(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 7 9' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        '7762852E-35A4-40FC-BA75-3D07C1D10D08'
      ),
      React.createElement('path', { d: 'M3.5 0L0 3.375.5 4 3 1.499V9l.999-2V1.499L6.5 4l.5-.625z', fill: 'currentColor', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default ArrowVertical;
//# sourceMappingURL=ArrowVertical.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/ArrowVertical.js